import {
  UpdateIconButton,
  formatBoolean,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@compass/core";

import { ListBeProperty } from "components";
import { Permission, PermissionAction, SchoolListDto, SchoolListResource, SortObject } from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { schoolPageRoute } from "../SchoolPage/SchoolPage";

export const SchoolTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  schools: SchoolListDto[];
  setSchools: (schools: SchoolListDto[]) => void;
  resource: SchoolListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "7%"}}>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SchoolListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SchoolListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SchoolListDto>("schoolType"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SchoolListDto>("nces"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell align="center">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SchoolListDto>("inactive"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.schools.map((schoolItem) => (
            <TableRow
              key={schoolItem.id}
              onClick={() =>
                navigate(
                  schoolPageRoute.getPath({
                    id: schoolItem.id,
                    crudMode: "view",
                    screenType: "dialog",
                  })
                )
              }
            >
              <TableCell>{schoolItem.id}</TableCell>
              <TableCell>{schoolItem.name}</TableCell>
              <TableCell>{schoolItem.schoolType}</TableCell>
              <TableCell>{schoolItem.nces}</TableCell>
              <TableCell align="center">{formatBoolean(schoolItem.inactive)}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() =>
                      navigate(
                        schoolPageRoute.getPath({
                          id: schoolItem.id,
                          crudMode: "edit",
                          screenType: "dialog",
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
